import type { ReactNode } from 'react';
import { T } from 'gt-react';
import { Input } from 'src/components/ui/input';
import { Label } from 'src/components/ui/label';
import { parseSortOrder } from '../task-pages/taskPageAdmin';

/**
 * The "Sort order" field shared by the page-admin editors (task pages, agent
 * pages, page sections): a non-negative whole number kept as a string while
 * editing so a cleared input can be flagged rather than coerced.
 */
export function SortOrderField({
  id,
  value,
  onChange,
  hint,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  /** Shown under the field while the value is valid. */
  hint?: ReactNode;
}) {
  const invalid = parseSortOrder(value) === null;
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>
        <T context="form field label for a page's or section's sort order">
          Sort order
        </T>
      </Label>
      <Input
        id={id}
        type="number"
        min={0}
        className="w-28"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {invalid ? (
        <p className="text-[11px] text-destructive">
          <T context="sort order validation error">
            Enter a whole number from 0 to 10000.
          </T>
        </p>
      ) : (
        hint && <p className="text-[11px] text-muted-foreground">{hint}</p>
      )}
    </div>
  );
}
